<app-pageheader [Parent]="this">
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="true" ApiUrl="infrastructure/lanes/searches"
  [AllowEdit]="false"
  EditUrl="/parking/accesscontrol/lanes/:id" [StructureViewerLayers]="StructureViewerLayers" StructureViewerForType="Lane">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>